<div class="layout-basic">
  <main class="layout-basic-main">
    <ng-content></ng-content>
  </main>
  <div class="layout-basic-footer">
    <ng-content select="lui-footer-basic"></ng-content>
  </div>
  <div class="layout-basic-bottom">
    <div *ngIf="showCookies" class="temp-cookies">Cookies</div>
  </div>
</div>
